import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorNft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.25 1.817a1.5 1.5 0 0 1 1.5 0l7.694 4.442a1.5 1.5 0 0 1 .75 1.299v8.884a1.5 1.5 0 0 1-.75 1.299l-7.694 4.442a1.5 1.5 0 0 1-1.5 0l-7.694-4.442a1.5 1.5 0 0 1-.75-1.3V7.559a1.5 1.5 0 0 1 .75-1.3l7.694-4.441Zm8.444 5.74L12 3.117 4.306 7.558v8.884L12 20.884l7.694-4.442V7.558Z"
    />
    <path
      fill="#F7A600"
      d="m9.33 15.011.305-5.261h-1.04l-.187 3.222L6.483 9.75h-.928l-.305 5.261h1.04l.188-3.229 1.924 3.229h.928ZM14.076 10.666l.053-.916h-3.511l-.306 5.261h1.041l.124-2.135h2.104l.053-.917H11.53l.075-1.293h2.47ZM18.676 10.666l.054-.916h-3.826l-.053.916h1.392l-.252 4.345h1.04l.253-4.345h1.392Z"
    />
  </svg>
);
export default SvgTwoColorNft;
